export default {"src":"/_next/static/media/offer-blue.498a8e0b.svg","height":646,"width":224};